{
  "name": "ui-thing",
  "version": "0.1.55",
  "description": "CLI used to add Nuxt 3 components to a project",
  "keywords": [
    "cli",
    "ui",
    "thing",
    "nuxt3",
    "radix-vue",
    "tailwindcss",
    "nuxtui",
    "shadcn-ui"
  ],
  "repository": {
    "url": "git+https://github.com/BayBreezy/ui-thing-cli.git"
  },
  "license": "MIT",
  "author": {
    "name": "Behon Baker",
    "email": "behon.baker@yahoo.com",
    "url": "https://behonbaker.com/"
  },
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "bin": {
    "ui-thing": "dist/index.js"
  },
  "scripts": {
    "build": "tsup",
    "clean": "rm -rf dist coverage node_modules package-lock.json && npm install",
    "coverage": "vitest run --coverage",
    "dev": "tsup --watch",
    "format": "npx prettier --write .",
    "release": "npm run build && npx changelogen@latest --release && npm publish && git push --follow-tags",
    "start": "node dist/index.js",
    "test": "vitest"
  },
  "dependencies": {
    "axios": "^1.8.1",
    "boxen": "^8.0.1",
    "build": "^0.1.4",
    "c12": "^2.0.4",
    "commander": "^13.1.0",
    "defu": "^6.1.4",
    "execa": "^9.5.2",
    "figlet": "^1.8.0",
    "fs-extra": "^11.3.0",
    "kleur": "^4.1.5",
    "lodash": "^4.17.21",
    "nypm": "^0.5.4",
    "ora": "^8.2.0",
    "prompts": "^2.4.2"
  },
  "devDependencies": {
    "@gmrchk/cli-testing-library": "^0.1.2",
    "@ianvs/prettier-plugin-sort-imports": "^4.4.1",
    "@types/figlet": "^1.7.0",
    "@types/fs-extra": "^11.0.4",
    "@types/lodash": "^4.17.15",
    "@types/node": "^22.13.5",
    "@types/prompts": "^2.4.9",
    "@vitest/coverage-v8": "^3.0.7",
    "magicast": "^0.3.5",
    "tsup": "^8.4.0",
    "typescript": "^5.7.3",
    "vitest": "^3.0.7"
  },
  "publishConfig": {
    "access": "public"
  }
}
